import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-412a90e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "input-group"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-plus customIcon",
  title: "Add"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash customIcon",
  title: "Cancel"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  for: "promp-text",
  class: "col-form-label w-100"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Selections: ")
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "mb-10"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No Values Found", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "mb-10" }
const _hoisted_17 = { class: "row d-flex align-items-center" }
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = { class: "customP" }
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { class: "modal-body" }
const _hoisted_28 = {
  key: 0,
  class: "input-group mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAdd)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Enter New Value",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newValue) = $event))
          }, null, 512), [
            [_vModelText, _ctx.newValue]
          ]),
          _createElementVNode("span", {
            class: "input-group-text",
            style: {"cursor":"pointer"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveValue()))
          }, _hoisted_3),
          _createElementVNode("span", {
            class: "input-group-text",
            style: {"cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAdd()))
          }, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAdd)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.isErrorEmpty)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Value is required."))
            : _createCommentVNode("", true),
          (_ctx.isErrorUnique)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Value must be unique."))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("i", {
              class: "fas fa-plus customIcon",
              title: "Add Select Value",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleAdd()))
            })
          ]),
          (_ctx.tokenType6ErrorMultiDefault.show)
            ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.tokenType6ErrorMultiDefault.text), 1))
            : _createCommentVNode("", true),
          (!_ctx.listOfJustTheValues || _ctx.listOfJustTheValues.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_draggable, {
              list: _ctx.listOfJustTheValues,
              disabled: false,
              "item-key": "name",
              class: "list-group col",
              "ghost-class": "ghost",
              move: () => {},
              onStart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragging = true)),
              onEnd: _ctx.checkMove
            }, {
              item: _withCtx(({ element }) => [
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'not-draggable': true }, "list-group-item text-left"])
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(element), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, [
                        _createElementVNode("i", {
                          class: "fas fa-trash customIcon px-2",
                          title: "Remove Select Value",
                          onClick: ($event: any) => (_ctx.deleteValue(element))
                        }, null, 8, _hoisted_22),
                        _createElementVNode("i", {
                          class: "fa-solid fa-pen-to-square customIcon px-2",
                          title: "Edit Selected value",
                          onClick: ($event: any) => (_ctx.showEditModal(element))
                        }, null, 8, _hoisted_23),
                        (_ctx.tokenValues.find((x) => x.value.toLowerCase() == element.toLowerCase()))
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: "fa-solid fa-thumbtack px-2 customIcon",
                              style: _normalizeStyle(`transform: rotate(90deg);font-size: 18px; float: right; color: ${_ctx.tokenValues.find((x) => x.value.toLowerCase() == element.toLowerCase()).isDefault ? 'green' : ''}`),
                              title: "Pin prompt",
                              onClick: ($event: any) => (_ctx.pinTokenValue(element))
                            }, null, 12, _hoisted_24))
                          : _createCommentVNode("", true),
                        (_ctx.tokenValues.find((x) => x.value.toLowerCase() == element.toLowerCase()))
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 1,
                              class: "fa-brands fa-creative-commons-zero customIcon px-2",
                              title: "Set as the 'None' option",
                              style: _normalizeStyle(`color:${_ctx.tokenValues.find((x) => x.value.toLowerCase() == element.toLowerCase()).isNone ? 'green' : ''}`),
                              onClick: ($event: any) => (_ctx.setAsNoneTokenValue(element))
                            }, null, 12, _hoisted_25))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["list", "move", "onEnd"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (_ctx.valueToEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valueToEdit.value) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.valueToEdit.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.valueToEdit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-success float-end",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editValue(_ctx.valueToEdit)))
                }, "Save"))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light float-end ms-2",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelEditValue()))
            }, "Cancel")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}